import { render, staticRenderFns } from "./AudioPlayerWithSubtitles.vue?vue&type=template&id=20a6b75c&scoped=true&"
import script from "./AudioPlayerWithSubtitles.vue?vue&type=script&lang=ts&"
export * from "./AudioPlayerWithSubtitles.vue?vue&type=script&lang=ts&"
import style0 from "./AudioPlayerWithSubtitles.vue?vue&type=style&index=0&id=20a6b75c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a6b75c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardText,VFileInput,VRow,VSheet})
